export default __webpack_public_path__ + "static/media/Frame 184 5.2dc33d22.png";